import { readableColor } from 'polished';
import { convertColorToThemeHexCode } from './colors.util';

/**
 * CSS rules to create ADA readable text color
 *
 * @param {string} backgroundColor Hex value of background color
 */
export default (backgroundColor) =>
  `
  background: ${backgroundColor};
  color: ${readableColor(
    backgroundColor,
    convertColorToThemeHexCode('white'),
    convertColorToThemeHexCode('black')
  )};
  `;
